import InputItem from 'antd-mobile/lib/input-item';
export default InputItem;



// WEBPACK FOOTER //
// ./components/input-item/index.tsx